import ExpandButton from './ExpandButton';

export default function ProjectOverview({ overview, isExpanded, onToggleExpanded }) {
  const shouldShowExpandButton = overview.length > 175;
  const displayText = isExpanded 
    ? overview 
    : `${overview.slice(0, 175)}${overview.length > 175 ? '...' : ''}`;

  return (
    <>
      {/* Overview text */}
      <div className="bg-gray-800/50 p-4 rounded-lg border border-emerald-400/20 mb-3 relative">
        <div className={`text-gray-300 text-sm leading-relaxed ${
          isExpanded ? 'overflow-y-auto h-full pr-2' : 'overflow-hidden h-full'
        }`}>
          <p style={{whiteSpace: 'pre-line'}}>
            {displayText}
          </p>
        </div>
      </div>

      {/* Show more/Show less button */}
      <div className="mb-3 h-6 flex items-center">
        {shouldShowExpandButton && (
          <ExpandButton 
            isExpanded={isExpanded}
            onToggle={onToggleExpanded}
          />
        )}
      </div>
    </>
  );
}